import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export default function ProfileInfo() {
  const { t } = useTranslation("global");
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const {id} = useParams();

  useEffect(() => {
    const fetchProfile = async () => {
      const userData = JSON.parse(localStorage.getItem("userDataLogin"));

      if (!userData || !userData.token) {
        toast.error(t("profile_info.error_loading_profile"));
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
        });
        
        const result = await response.json();

        if (result && result.data) {
          setProfile(result.data);
        } else {
          toast.error(result.message || t("profile_info.error_loading_profile"));
        }
      } catch (error) {
        toast.error(t("profile_info.error_loading_profile"));
        console.error("Error fetching profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);


  if (loading) return <div>{t("profile_info.loading")}</div>;
  if (!profile) return <div>{t("profile_info.error_loading_profile")}</div>;

  
  return (
    <>
{profile?.student?.map((student, index) => {
  if (student.id == id) {
    return (
      <div key={student.id || index}>
        <div className="custom-section">
          <div className="container">
            <h1 className="m-0 mb-3">{student.name} {t("profile_info.profile")}</h1>
            <h6 className="m-0">
              <Link className="link-hover" to="/">{t("profile_info.home")}</Link>
              <span> - </span><span className="link-hover">{t("profile_info.your_profile")}</span>
              <span> - </span><span className="second-color">{t("profile_info.profile_details")}</span>
            </h6>
          </div>
        </div>

        <div className="container my-4">
          <div style={{ backgroundColor: "#FCF8F8", borderRadius: "10px" }} className="row p-3">
            <div className="d-flex flex-wrap align-items-center">
              <div>
                <img
                  style={{ width: "200px", height: "200px", borderRadius: "50%" }}
                  src={student.image || "https://static.vecteezy.com/system/resources/thumbnails/026/911/382/small_2x/happy-student-boy-with-books-isolated-free-photo.jpg"}
                  alt="Student Profile"
                  className="mb-4"
                />
              </div>
<div className="row">
<div className="mx-4 student-info-pro" >
                <h3>{student.name}</h3>
                <p className="paragraph-color email-2">{student.email}</p>
                <p className="paragraph-color">{student.code_student}</p>
              </div>
</div>
            </div>

            <div className="col-md-12 mb-2 mt-3">
              <label>{t("profile_info.name")}</label>
              <h2 className="form-control mt-1 py-2">{student.name}</h2>
            </div>

            <div className="col-md-12 mb-2">
  <label>{t("profile_info.email")}</label>
  <input
    type="email"
    className="form-control mt-1 py-2"
    value={student.email}
    readOnly
  />
</div>


            <div className="col-md-12 mb-2">
              <label>{t("profile_info.birth_year")}</label>
              <h2 className="form-control mt-1 py-2">{student.birthdate || t("profile_info.not_provided")}</h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
})}


      {/* عرض الكورسات الخاصة بالابن المحدد */}
      <div className="container my-4">
        <div className="row my-3">
          {profile?.student?.map((student, index) => (
            student.id == id && (
              <div key={student.id || index} className="col-md-12">
                <div className="row my-3">
                  {student.courses && student.courses.length > 0 && student.courses.map((course, idx) => {
                    const courseImages = JSON.parse(course.image || "[]");
                    const courseImageUrl = courseImages.length > 0 ? courseImages[0] : "";
                    const instructor = course.instructors && course.instructors.length > 0 ? course.instructors[0] : null;

                    return (
                      <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={course.id || idx}>
                        <div className="card custom-card h-100" style={{ cursor: "pointer" }}>
                          <img src={courseImageUrl} alt="Course" className="card-img" />
                          <div className="card-body">
                            <div className="card-info">
                              <span>
                                <i className="bi bi-journal-text paragraph-color me-2"></i>
                                {course.lessons} {t('onlineCourses2.lessons')}
                              </span>
                            </div>
                            <h3 className="card-title">{course.name}</h3>

                            {instructor && (
                              <div className="card-instructor">
                                <img src={instructor.image} alt={instructor.name} />
                                <span>{instructor.name}</span>
                              </div>
                            )}

                            <div className="card-footer">
                              <span className="price">
                                {course.type === "free" ? t('free') : course.price}
                              </span>
                              <span className="details">
                                {course.type === "free"
                                  ? t('Free')
                                  : course.purshed === 1
                                  ? t('AlreadyPaid')
                                  : t('Free')}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )
          ))}
        </div>
      </div>
    </>
  );
}
